export const CHOOSE_ROLE = 'CHOOSE_ROLE';

export const UPDATE_SCORE = 'UPDATE_SCORE';

export const UPDATE_PEERSCORE = 'UPDATE_PEERSCORE';

// export const RESET_SCORES = 'RESET_SCORES';t

export const INIT_SCORES = 'INIT_SCORES';

export const CHOOSE_LANG = 'CHOOSE_LANG';

export const CHOOSE_QUESTIONS = 'CHOOSE_QUESTIONS';

export const NAV_QUESTION = 'NAV_QUESTION';

export const TOGGLE_DEMO = 'TOGGLE_DEMO';

export const SET_LABEL = 'SET_LABEL';